import apiClient from '../axios'

export async function all(countryId) {
  return apiClient
    .get(`/country/${countryId}/counties/all`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function list(countryId, page, sorting) {
  const sortingQuery = sorting ? `&sort=${sorting.column}&direction=${sorting.direction}` : '';

  return apiClient
    .get(`/country/${countryId}/counties?page=${page}${sortingQuery}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}


export async function details(countryId, id) {
  return apiClient
    .get(`/country/${countryId}/counties/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put(`/country/${data.countryId}/counties`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(countryId, id, data) {
  return apiClient
    .post(`/country/${countryId}/counties/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function remove(countryId, id) {
  return apiClient
    .delete(`/country/${countryId}/counties/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
